import { motion } from "framer-motion";
import PageTransition from "./templateParts/PageTransition";
import Lottie from "lottie-react";
import intro from "@/assets/lottie/404.json";
import "./notFoundStyles.scss";

const VARIANTS = {
  hidden: {
    opacity: 0,
    x: "20px",
  },
  visible: {
    opacity: 1,
    x: "0",
  },
};

const NotFound = () => {
  const parentVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.5,
      },
    },
  };

  return (
    <PageTransition>
      <motion.section
        animate="hidden"
        className="not-found"
        initial="hidden"
        variants={parentVariants}
        viewport={{ once: true }}
        whileInView="visible"
      >
        <motion.div className="lottie-container" variants={VARIANTS}>
          <Lottie animationData={intro} loop={true} />
        </motion.div>
        <motion.p className="disclaimer" variants={VARIANTS}>
          Page not found
        </motion.p>

        <motion.div className="links-container" variants={VARIANTS}></motion.div>
      </motion.section>
    </PageTransition>
  );
};

export default NotFound;
